import React, { FC, ReactNode, useContext } from 'react';
import './ProductSelectionHeader.scss';
import { ProductSelectionAction } from './ProductSelectionTypes';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/appState';
import classNames from 'classnames';
import MaterialIcon from '../common/MaterialIcon';
import { ProductSelectionContext } from './ProductSelectionContext';
import { getProductSelectionCount, hasProductSelection } from './ProductSelectionUtils';
import { useTranslation } from 'react-i18next';

export const ProductSelectionHeader: FC<{ header: ReactNode; menu: ReactNode }> = ({ menu, header }) => {
    const { t } = useTranslation();
    const [state, dispatch] = useContext(ProductSelectionContext);

    const cancelSelection = () => dispatch({ type: ProductSelectionAction.CLOSE });
    const isSticky = useSelector((state: AppState) => state.header.isSticky);

    return (
        <div className="product-selection-wrapper">
            <div
                className={classNames('product-selection-slider', {
                    showHeader: !hasProductSelection(state),
                    showSelection: hasProductSelection(state)
                })}
            >
                <div className={classNames('content-header')}>{header}</div>
                <div
                    className={classNames('product-selection-container', {
                        sticky: isSticky && hasProductSelection(state)
                    })}
                >
                    <div className="product-selection-menu" data-testid="ProductSelectionMenu">
                        <button className="close" onClick={cancelSelection}>
                            <MaterialIcon icon="clear" />
                        </button>
                        <div className="selected-count">
                            {hasProductSelection(state) ? (
                                <span>
                                    {t('shop.subscriptions.selectionCount', {
                                        count: getProductSelectionCount(state)
                                    })}
                                </span>
                            ) : null}
                        </div>
                        {menu}
                    </div>
                </div>
            </div>
        </div>
    );
};
